module.exports = __webpack_public_path__ + "static/media/fondo-slider-2.32520460.jpg";